import React from 'react';
import LoaderGif from "../../styles/images/loader_nw.gif";


type LoaderProps = {
    customAlt?: string;
};

const Loader:React.FC<LoaderProps> = ({customAlt='Loading...'}) => {
    const loadingProgressStyle: React.CSSProperties | any = {
        position: "fixed" as "fixed",
        zIndex: "9999999",
        width: "100%",
        height: "100%",
        background: "#ffffff",
        top: 0,
    };
    const imgStyle: React.CSSProperties | any = {
        position: "absolute" as "absolute",
        left: "-23%",
        right: "0",
        margin: "0 auto",
        top: "50%",
    };
    return (
            <div style={loadingProgressStyle}>
                <img style={imgStyle} src={LoaderGif} alt={customAlt}/>
            </div>
    );
};

export default Loader;
